import React from 'react';
import { Link } from 'react-router-dom';
const Footer = () => {
  return <footer className="bg-charcoal text-cream py-12 w-full" data-id="element-34">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-35">
        <h3 className="text-burgundy font-display text-2xl font-bold mb-2" data-id="element-36">
          Chef<span className="text-sage" data-id="element-37">Chat</span>
        </h3>
        <p className="text-cream/80 mb-6" data-id="element-38">
          Your AI Sous Chef for Customer Communications
        </p>
        <p className="text-cream/60 text-sm mb-4" data-id="element-39">
          © 2025 ChefChat. All rights reserved. EWHALLET DIGITAL SDN. BHD.
        </p>
        <div className="text-cream/60 text-sm mb-2" data-id="element-40">
          <Link to="/privacy" className="hover:text-sage transition-colors" data-id="element-41">
            Privacy Policy
          </Link>
          <span className="mx-2" data-id="element-42">|</span>
          <Link to="/terms" className="hover:text-sage transition-colors" data-id="element-43">
            Terms of Service
          </Link>
        </div>
        
      </div>
    </footer>;
};
export default Footer;